import { useEffect, useRef } from "react";
import { Helmet } from "react-helmet";

import Div from "../components/Div";
import PageHeader from "../components/PageHeader";

import Compass from "../icons/Compass";
import EnvelopeFill from "../icons/EnvelopeFill";
import TelephoneFill from "../icons/TelephoneFill";

const Sales = () => {
  const formRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!formRef.current) return;

    const target = formRef.current;
    const script = document.createElement("script");
    script.src = "https://js-na3.hsforms.net/forms/embed/342381409.js";
    script.defer = true;
    target.appendChild(script);

    return () => {
      target.innerHTML = "";
    };
  }, []);

  return (
    <Div flex flexColumn height={100}>
      <Helmet titleTemplate="InTouch | %s">
        <title>Sales</title>
        <meta
          name="description"
          content="Let us share our amazing platform with your school district."
        />
      </Helmet>

      <PageHeader title="Sales" subtitle="" />
      <Div container flexShrink={0}>
        <Div row marginY={3}>
          <Div col>
            <h4 className="mt-2 mb-3">Corporate Office</h4>
            <Div>
              <Div>
                <span className="me-2">
                  <Compass />
                </span>
                420 N Meridian Street
              </Div>
              <Div>
                <span className="me-2 invisible">
                  <Compass />
                </span>
                Suite B
              </Div>
              <Div>
                <span className="me-2 invisible">
                  <Compass />
                </span>
                Puyallup, WA 98371
              </Div>
            </Div>
            <Div classNames={["mt-2"]}>
              <TelephoneFill />
              <span className="ms-2">+1 (800) 627-4767</span>
            </Div>
            <Div classNames={["mt-2"]}>
              <TelephoneFill />
              <span className="ms-2">+1 (253) 922-6077</span>
            </Div>
            <Div classNames={["mt-2"]}>
              <EnvelopeFill />
              <a className="ms-2" href="mailto:sales@intouchreceipting.com">
                sales@intouchreceipting.com
              </a>
            </Div>
            <Div classNames={["mt-2"]}>
              <strong>Fax</strong>
              <span className="ms-2">+1 (253) 922-6154</span>
            </Div>

            <h4 className="mt-5 mb-3">Texas Office</h4>
            <Div>
              <Div>
                <span className="me-2">
                  <Compass />
                </span>
                Dallas, TX
              </Div>
            </Div>
            <Div classNames={["mt-2"]}>
              <TelephoneFill />
              <span className="ms-2">+1 (800) 627-4767</span>
            </Div>
          </Div>

          <Div colMd={6} marginTop={5} marginTopMd={0}>
            <h4 className="mt-2 mb-3">Request Information</h4>
            <p>Thank you for your interest in InTouch.</p>
            <p>We look forward to speaking with you soon!</p>
            <div
              ref={formRef}
              className="hs-form-frame"
              data-region="na3"
              data-form-id="b5589bc3-675c-4d70-9b75-29712d2c09f7"
              data-portal-id="342381409"
            ></div>
          </Div>
        </Div>
      </Div>
    </Div>
  );
};

export default Sales;
